<template>
    <div class="common-process">
        <div class="title">常用流程</div>
        <div class="container">
            <div class="classify classify-1">
                <div class="sub-title"><span class="line"></span>人事&考勤</div>
                <div class="items">
                    <template v-for="(item, index) in classifyOne">
                        <Widget :key="index" :item="item" @callback="handleWidgetClick"></Widget>
                    </template>
                </div>
            </div>
            <div class="classify classify-2">
                <div class="sub-title"><span class="line"></span>差旅&行政</div>
                <div class="items">
                    <template v-for="(item, index) in classifyTwo">
                        <Widget :key="index" :item="item" @callback="handleWidgetClick"></Widget>
                    </template>
                </div>
            </div>
            <div class="classify classify-3">
                <div class="sub-title"><span class="line"></span>其他最近使用</div>
                <div class="fast-process">
                    <template v-for="(item, index) in fastProcessData">
                        <div :key="index" :class="[{ isActive: item.isActive }, 'item']" @click="handleClick(item)">
                            {{ item.name }}
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const classifyOne = [
    { id: 1, name: "请假申请", key: "QJSQ", icon: "qingjia", url: "" },
    { id: 2, name: "补卡申请", key: "BKSQ", icon: "buka", url: "" },
    { id: 3, name: "加班申请", key: "JBSQ", icon: "jiaban", url: "" },
    { id: 4, name: "转正申请", key: "ZZSQ", icon: "zhuanzheng", url: "" },
    { id: 5, name: "离职申请", key: "LZSQ", icon: "lizhi", url: "" },
    { id: 6, name: "销假申请", key: "XJSQ", icon: "xiaojia", url: "" },
];
const classifyTwo = [
    { id: 7, name: "出差申请", key: "BX_CCSQ", icon: "chuchai", url: "" },
    { id: 8, name: "差旅费报销", key: "BX_CLFYBX", icon: "chailvfeibaoxiao", url: "" },
    { id: 9, name: "私车公用申请", key: "BX_SCGYSQ", icon: "sichegongyongshenqing", url: "" },
    { id: 10, name: "私车公用报销", key: "BX_SCGYBX", icon: "sichegongyongbaoxiao", url: "" },
    { id: 11, name: "业务招待费报销", key: "BX_YWZDFBX", icon: "yewuzhaodaifeiyong", url: "" },
    { id: 12, name: "其他费用报销", key: "BX_QTFYBX", icon: "qitafeiyongbaoxiao", url: "" },
];
import Widget from "./widget.vue";
import { getRecentProcess, getProcessQuick } from "@/api";
export default {
    name: "CommonProcess",
    components: {
        Widget,
    },
    props: {},
    data() {
        return {
            classifyOne: new Array().concat(classifyOne),
            classifyTwo: new Array().concat(classifyTwo),
            fastProcessData: [],
            quickEnum: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            this.loadRecentProcess();
            this.loadProcessQuick();
        },

        // 加载最近流程
        loadRecentProcess() {
            getRecentProcess().then((res) => {
                if (res.status) {
                    this.recentProcessDataConversion(res.body);
                }
            });
        },
        loadProcessQuick() {
            getProcessQuick().then((res) => {
                if (res.status) {
                    this.quickEnum = res.body;
                }
            });
        },

        // 接口数据映射
        recentProcessDataConversion(data) {
            if (data.length === 0) {
                return;
            }
            this.fastProcessData = [];
            data.forEach((ele) => {
                let obj = {
                    id: ele.id,
                    url: ele.url,
                    isActive: false,
                    name: ele.processName,
                    ifNbpm: ele.ifNbpm,
                    openWay: ele.openWay || 0,
                };
                this.fastProcessData.push(obj);
            });
        },

        handleWidgetClick(item) {
            for (let index = 0; index < this.quickEnum.length; index++) {
                const ele = this.quickEnum[index];
                if (ele.code === item.key) {
                    let params = {
                        id: ele.id,
                        isProcess: true,
                    };
                    this.$emit("loadProcessUrlById", params, ele);
                }
            }
        },

        handleClick(item) {
            this.fastProcessData.forEach((item) => {
                if (item.isActive) {
                    item.isActive = false;
                }
            });
            item.isActive = true;
            let params = {
                id: item.id,
                isProcess: true,
            };
            this.$emit("loadProcessUrlById", params, item);
        },
    },
};
</script>

<style scoped lang="scss">
.common-process {
    padding: 0 20px;
    height: 100%;
    font-family: PingFangSC-Medium, PingFang SC;
    .title {
        font-size: 16px;
        font-weight: 500;
        line-height: 22px;
        color: #666666;
        padding: 20px 0 10px 0;
        border-bottom: 1px solid #d9d9d9;
    }
    .container {
        display: flex;
        flex-direction: column;
        height: calc(100% - 55px);
        overflow: auto;
        .classify {
            width: 100%;
            margin-top: 20px;
            padding-bottom: 12px;
            .sub-title {
                height: 20px;
                font-size: 14px;
                font-weight: 400;
                color: #000000;
                line-height: 20px;
                margin-bottom: 10px;
                display: flex;
                align-items: center;
                .line {
                    height: 16px;
                    width: 2px;
                    margin-right: 4px;
                    display: inline-block;
                    background-color: #3a9d80;
                }
            }
            .items {
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;
            }
            .fast-process {
                margin-top: 12px;
                overflow: auto;
                height: calc(100% - 20px);
                .item {
                    padding: 6px 0;
                    display: flex;
                    color: #333;
                    cursor: pointer;
                    font-size: 14px;
                    align-items: center;
                }
                .item:hover {
                    color: #3a9d80;
                    background-color: #f5f7fa;
                }
                .isActive {
                    color: #3a9d80;
                    background-color: #fff;
                }
                .isActive:hover {
                    color: #3a9d80;
                    background-color: #fff;
                }
                .item::before {
                    content: "";
                    width: 2px;
                    height: 2px;
                    border-radius: 50%;
                    display: inline-block;
                    margin-right: 6px;
                    background-color: #3a9d80;
                }
            }
        }
        .classify-1 {
            height: 112px;
        }
        .classify-2 {
            height: 130px;
        }
        .classify-3 {
            flex: 1;
            overflow: hidden;
        }
    }
}
</style>
